var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-content"},[_c('img',{attrs:{"src":"/liquor/暂无内容 （金装版）.png"}}),_c('div',[_vm._v("开发中，尽情期待！")])])}]

export { render, staticRenderFns }